import { Link } from "react-router-dom";
import { Box, Button, Typography, Link as MUILink } from "@mui/material";

import { SUPPORT_EMAIL } from "@/utils/staticData/contacts";
import {useDispatch} from "react-redux";
import {setCartData} from "@/redux-store/cart/cartSlice.ts";

const ConfirmationFooter = () => {
    const dispatch = useDispatch();

    const handleBackToHome = () => {
        dispatch(
            setCartData({
                products: [],
                totalItems: 0,
                totalAmount: 0,
                hasPlan: false,
                hasDevice: false,
            })
        );
    };

  return (
    <>
      <Button
        variant="contained"
        type="button"
        component={Link}
        to="/"
        onClick={handleBackToHome}
        fullWidth
        sx={{ mt: { xs: 0, md: 3 }, mb: { xs: 3, md: 5 } }}
      >
        Back to home
      </Button>
      <Typography
        variant="body1"
        fontSize={"1rem !important"}
        color="text.primary"
        textAlign="center"
      >
        Have a question?
      </Typography>
      <Box
        display={{ xs: "block", md: "flex" }}
        gap={{ xs: 0, md: 0.5 }}
        justifyContent="center"
      >
        <Typography
          variant="body1"
          fontSize={"1rem !important"}
          color="text.primary"
          textAlign="center"
        >
          Contact us at
        </Typography>
        <MUILink
          href={`mailto:${SUPPORT_EMAIL}`}
          underline="hover"
          color="primary.main"
          textAlign="center"
        >
          <Typography
            variant="body1"
            fontSize={"1rem !important"}
            color="inherit"
          >
            {SUPPORT_EMAIL}
          </Typography>
        </MUILink>
      </Box>
    </>
  );
};

export default ConfirmationFooter;
